/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { defaultTheme } from '@vital-ui/react-theme';
import Trigger from 'rc-trigger';
import 'rc-trigger/assets/index.css';
import * as React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { placements } from './placements';
import { rcTooltipStyle } from './styled';
var TooltipContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 8px 16px;\n  text-align: center;\n  color: ", ";\n  background: ", ";\n  border-radius: 4px;\n"], ["\n  display: inline-block;\n  padding: 8px 16px;\n  text-align: center;\n  color: ", ";\n  background: ", ";\n  border-radius: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.tooltip.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.tooltip.bg;
});
var RcTooltipStyle = createGlobalStyle(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n", ";\n"], ["\n", ";\n"])), rcTooltipStyle);
TooltipContent.defaultProps = {
    theme: defaultTheme,
};
var TooltipArrow = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export var Tooltip = function (_a) {
    var children = _a.children, popupStyle = _a.popupStyle, popup = _a.popup, placement = _a.placement, popupPlacement = _a.popupPlacement, props = __rest(_a, ["children", "popupStyle", "popup", "placement", "popupPlacement"]);
    var TooltipBase = function () { return [
        React.createElement(TooltipArrow, { className: "rc-tooltip-arrow", key: "arrow" }),
        React.createElement(TooltipContent, __assign({ key: "content" }, popupStyle), popup),
    ]; };
    return (React.createElement(React.Fragment, null,
        React.createElement(Trigger, __assign({ popupPlacement: popupPlacement || placement, popup: TooltipBase, builtinPlacements: placements }, props), children),
        React.createElement(RcTooltipStyle, null)));
};
Tooltip.defaultProps = {
    action: ['hover'],
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0,
    popupClassName: 'vital-popup',
    destroyPopupOnHide: false,
    placement: 'bottom',
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Tooltip.js.map